<template>
    <v-select 
       :value="selected_gebrcodes" 
       v-model="selectedgebrcodes"
       v-bind:items="filtered_users"
       item-value="code" 
       item-text="name" 
       :label="label"
       :dense="isDense" 
       :multiple="isMultiple"
       :clearable="isClearable"
       @change="updateData"
       v-on:click:clear="callClear()">
       <template v-slot:prepend-item >
            <div v-if="canSelectAll">
                <v-list-item ripple @mousedown.prevent @click="toggle">
                    <v-list-item-action>
                        <v-icon :color="selectedgebrcodes.length > 0 ? 'indigo darken-4' : ''"> {{ getIcon() }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Select All</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
            </div>
            <div v-if="isSearchable">
                <v-list-item>
                    <v-list-item-content>
                        <v-text-field v-model="searchGebr" placeholder="Search" :clearable="true"></v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-1"></v-divider>            
            </div>
        </template>       
        <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index >= 0 && index < visibleChips">
                <span>{{ item.code }}</span>
            </v-chip>
            <span v-if="index === visibleChips" class="grey--text text-caption">(+{{ selectedgebrcodes.length - visibleChips }})</span>
        </template>                                                                    
    </v-select>
</template>

<script>
export default {
    props: {
        selected_gebrcodes: {
            type: Array,
            default: function() { return []; },
        },
        label: String,
        field: {
            default: 'gebr',
            required: true,
        },
        isClearable:{
            type: Boolean,
            default: false
        }, 
        showInactive: {
            type: Boolean,
            default: false
        },
        isDense:{
            type: Boolean,
            default: false
        },
        vfyEmailsOnly:{
            type: Boolean,
            default: false
        },
        isAgent:{
            type: Boolean,
            default: false
        },
        visibleChips:{
            type: Number,
            default: 10
        },        
        canSelectAll: {
            type: Boolean,
            default: false
        },
        isMultiple: {
            type: Boolean,
            default: false
        },    
        isSearchable: {
            type: Boolean,
            default: false
        },                
        localStorageItem:{
            type: String,
            default: 'list.acco.gebrcodes'
        },
        customOption: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        filtered_users: function() { // filter on user being active    
            return this.gebrcodes.filter(el => {
                let check_active = this.showInactive ? false : el.active;
                let check_email = this.vfyEmailsOnly ? el.email.includes('@villaforyou.com') : true;
                let check_agent = this.isAgent ? el.agent : true;
                let check_search = true
                if(this.searchGebr){
                  check_search = el.name.toLowerCase().indexOf(this.searchGebr.toLowerCase()) > -1;
                }
                return (check_active && check_email && check_agent && check_search) || el.custom;
            });            
        },
    },    
    data() {
        return {
            gebrcodes: [],
            selectedgebrcodes: [],
            searchGebr: ''
        }
    },
    created() {
        //console.log('gebr - created')
        this.getGebrCodes();
    },
    methods: {
        callClear(){
            this.selectedstatcodes = [];
        },
        getIcon: function () {
            if (this.isAllSelected()) return 'mdi-close-box'
            if (this.isSomeSelected()) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },    
        isAllSelected: function () {
            return this.selectedgebrcodes.length === this.filtered_users.length; 
        },
        isSomeSelected: function () {            
            return this.selectedgebrcodes.length > 0 && this.selectedgebrcodes.length !== this.filtered_users.length;
        },   
        toggle() {
            this.$nextTick(() => {
                if (this.isAllSelected()) {
                    this.selectedgebrcodes = [];
                    this.updateData();
                } else {
                    this.selectAll();
                    this.updateData();
                }
            })
        },
        selectAll(){
            this.selectedgebrcodes = [];
            this.filtered_users.forEach(x => {
                this.selectedgebrcodes.push(x.code);
            });
        }, 
        updateData(){              
            this.$emit('updateData', { "field": this.field, "value": this.selectedgebrcodes })
        },        
        getGebrCodes() {
            this.$axios
                .post("ares/json/ares/misc/getGebr.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getGebr"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log('error', res.data.error.message);
                    } else {
                        //console.log('res', res.data)
                        if (this.customOption && typeof this.customOption === 'object' && Object.keys(this.customOption).length > 0 && this.customOption.custom===true) {
                            this.gebrcodes.push(this.customOption);
                        }
                        this.gebrcodes = [...this.gebrcodes, ...res.data.getGebr];
                        if(localStorage.getItem(this.localStorageItem)!==null){
                           this.selectedgebrcodes=localStorage.getItem(this.localStorageItem).split(",");
                        } else {
                           this.selectAll();
                        }
                        this.updateData();                        
                    }
                })
        },
    }
}

</script>